// src/app/enums/project-type.enum.ts

export enum ProjectType {
  WORLD_CUP = 1,
  TIER_LIST = 2,
  KMK = 3,
}

export const ProjectTypeLabels: Record<ProjectType, string> = {
  [ProjectType.WORLD_CUP]: 'World Cup',
  [ProjectType.TIER_LIST]: 'Tier List',
  [ProjectType.KMK]: 'KMK',
};

export const ProjectTypeIcons: Record<ProjectType, string> = {
  [ProjectType.WORLD_CUP]: 'fas fa-list-check',
  [ProjectType.TIER_LIST]: 'fas fa-layer-group',
  [ProjectType.KMK]: 'fas fa-heart',
};

// Colores para cada tipo (usando clases de Tailwind)
export const ProjectTypeColors: Record<ProjectType, string> = {
  [ProjectType.WORLD_CUP]: 'text-blue-300',
  [ProjectType.TIER_LIST]: 'text-purple-300',
  [ProjectType.KMK]: 'text-yellow-300',
};

export const ProjectTypeBadgeColors: Record<ProjectType, string> = {
  [ProjectType.WORLD_CUP]:
    'bg-blue-100/80 dark:bg-blue-900/50 border-blue-700 dark:border-blue-500/30 text-blue-700 dark:text-blue-300',
  [ProjectType.TIER_LIST]:
    'bg-purple-100/80 dark:bg-purple-900/50 border-purple-700 dark:border-purple-500/30 text-purple-700 dark:text-purple-300',
  [ProjectType.KMK]:
    'bg-yellow-100/80 dark:bg-yellow-900/50 border-yellow-700 dark:border-yellow-500/30 text-yellow-700 dark:text-yellow-300',
};

// Helper functions
export function getProjectTypeLabel(
  type: ProjectType | number | null | undefined,
): string {
  if (type == null) return 'Unknown';
  return ProjectTypeLabels[type as ProjectType] ?? 'Unknown';
}

export function getProjectTypeIcon(
  type: ProjectType | number | null | undefined,
): string {
  if (type == null) return 'fas fa-question';
  return ProjectTypeIcons[type as ProjectType] ?? 'fas fa-question';
}

export function getProjectTypeColorClass(
  type: ProjectType | number | null | undefined,
): string {
  if (type == null) return 'text-gray-300';
  return ProjectTypeColors[type as ProjectType] ?? 'text-gray-300';
}

export function getProjectTypeBadgeClass(
  type: ProjectType | number | null | undefined,
): string {
  if (type == null) return 'bg-gray-900/30 border-gray-500/30 text-gray-300';
  return (
    ProjectTypeBadgeColors[type as ProjectType] ??
    'bg-gray-900/30 border-gray-500/30 text-gray-300'
  );
}

export function getAllProjectTypes(): Array<{
  value: ProjectType;
  label: string;
  icon: string;
  color: string;
}> {
  return Object.values(ProjectType)
    .filter((v): v is ProjectType => typeof v === 'number')
    .map((value) => ({
      value,
      label: getProjectTypeLabel(value),
      icon: getProjectTypeIcon(value),
      color: getProjectTypeColorClass(value),
    }));
}
